import sortBy from 'lodash/sortBy';
import getTime from './getTime';

const ChannelCardTypeEnum = {
  video: 'VIDEO',
  audio: 'AUDIO',
  pdf: 'PDF',
  webUrl: 'WEB_URL',
  html: 'HTML',
  html_v2: 'HTML_V2',
  embed: 'EMBED'
};

export default function tranformChannel(
  { channel: channels, channelCard: allChannelCards, states },
  channelPage
) {
  const stateEntity = states.reduce((acc, currentVal) => {
    if (currentVal) {
      return {
        ...acc,
        [currentVal.contentId]: currentVal
      };
    }
    return acc;
  }, {});
  const completeLibrary = [];
  if (channels && channels.length > 0) {
    const sortedChannels = sortBy(channels, 'name');
    const sortedChannelCards = sortBy(allChannelCards, 'position');
    sortedChannels.forEach(channel => {
      const approvedChannelCards = [];
      sortedChannelCards.forEach(card => {
        if (card.rootOfferId === channel.contentId) {
          const transformedCard = {
            id: card.contentId,
            pid: card.contentId,
            name: card.name,
            updatedAt: card.updatedAt,
            createdAt: getTime(card.createdAt),
            channelCardType: ChannelCardTypeEnum[card.type],
            webThumbUrl: card.webThumbUrl,
            duration: card.duration,
            cardMeta: card.cardMeta,
            rootOfferId: card.rootOfferId,
            modelType: card.modelType,
            url: card.url,
            narrationUrl: card.narrationUrl,
            htmlContent: card.htmlContent,
            position: card.position,
            state: stateEntity[card.contentId]
          };
          if (!card.deleted) {
            approvedChannelCards.push(transformedCard);
          }
        }
      });
      const transformedChannel = {
        id: channel.contentId_version,
        pid: channel.contentId,
        name: channel.name,
        priority: channel.priority,
        image: channel.image,
        description: channel.description,
        isFollowed: false, // TODO
        approvedChannelCards,
        createdAt: getTime(channel.createdAt)
      };
      const noOfPosts = sortedChannelCards.filter(
        card => card.rootOfferId === channel.contentId && !card.deleted
      ).length;
      if (!channel.deleted && (noOfPosts || channelPage)) {
        completeLibrary.push(transformedChannel);
      }
    });
  }
  return completeLibrary;
}
